if(!customElements.get("carousel-component")) {
  class Carousel extends HTMLElement {
    constructor() {
      super();
      this.carouselElement = this;
      
      this.desktopPerPage = this.carouselElement.dataset['desktopperpage'] || 4;
      this.mobilePerPage = this.carouselElement.dataset['mobileperpage'] || 1;
      this.tabletPerPage = this.carouselElement.dataset['tabletperpage'] || 3;
      this.focus = this.carouselElement.dataset['focus'];
      this.type = this.carouselElement.dataset['type'];
      this.height = this.carouselElement.dataset['height'] || '40rem';
      this.heightRatio = this.carouselElement.dataset['heightratio'];
      this.gap = this.carouselElement.dataset['gapbetweenslides'] || 0;
      this.gapMobile = this.carouselElement.dataset['gapbetweenslidesonmobile'] || 0;
      this.autoplaySpeed = parseInt(this.dataset['autoplaySpeed']) || 3000;
      this.direction = this.carouselElement.dataset['direction'] || 'ltr';
      this.mobileDirection = this.carouselElement.dataset['mobiledirection'] || this.direction;
      this.tabletDirection = this.carouselElement.dataset['tabletdirection'] || this.direction;
      this.perMove = this.carouselElement.dataset['permove'] || 1;
      this.tabletpermove = this.carouselElement.dataset['tabletpermove'] || 1;
      this.mobilepermove = this.carouselElement.dataset['mobilepermove'] || 1;
      this.mobilePaddingLeft = this.carouselElement.dataset['mobilepaddingleft'] || '0';
      this.mobilePaddingRight = this.carouselElement.dataset['mobilepaddingright'] || '0';
      this.tabletPaddingLeft = this.carouselElement.dataset['tabletpaddingleft'] || '0';
      this.tabletPaddingRight = this.carouselElement.dataset['tabletpaddingright'] || '0';
      this.desktopPaddingLeft = this.carouselElement.dataset['desktoppaddingleft'] || '0';
      this.desktopPaddingRight = this.carouselElement.dataset['desktoppaddingright'] || '0';
      this.rewindDesktop = this.carouselElement.dataset.rewindDesktop || false;
 
      // Data attribute string matching for correct boolean value
      this.showarrows = this.carouselElement.dataset['showarrows'] === 'true' || false;
      this.autoplay = this.carouselElement.dataset['autoplay'] === 'true' || false;
      this.showarrowsonmobile = this.carouselElement.dataset['showarrowsonmobile'] === 'true' || false;
      this.showdots = this.carouselElement.dataset['showdots'] === 'true' || false;
      this.showdotsonmobile = this.carouselElement.dataset['showdotsonmobile'] === 'true' || false;
      this.isNavigation = this.carouselElement.dataset['isnavigation'] === 'true' || false;
      this.disableDrag = this.carouselElement.dataset['disabledrag'] === 'true' || false;
      this.destroyOnMobile = this.carouselElement.dataset['enableonmobile'] === 'false' || false;
      this.destroyOnDesktop = this.carouselElement.dataset['enableondesktop'] === 'false' || false;
      this.omitEnd = this.carouselElement.dataset['omitEnd'] == 'false' || false;
      this.updateOnMove = this.carouselElement.dataset['updateonmove'] === 'true'; 
      this.refresh = this.carouselElement.dataset['refresh'] == 'true' || false;
      this.sync = this.carouselElement.dataset['carouselsyncselector'] || false;
      this.disableWheel = this.carouselElement.dataset['disableWheel'] === 'true';

      // Carousel element should have class splide
      if (!this.carouselElement.classList.contains('splide')) return;
      this.initCarousel();
    }
    
    initCarousel() {
      if (this.destroyOnMobile && this.destroyOnDesktop) return;
      
      // Build config object
      const config = {
        perPage: this.desktopPerPage,
        ...(this.updateOnMove ? { updateOnMove: true } : {}), // <<< Only add if data-updateonmove="true"
        ...(this.type ? { type: this.type } : {}),
        ...(this.focus ? { focus: this.focus } : {}),
        autoplay: this.autoplay,
        interval: this.autoplaySpeed,
        gap: this.gap,
        snap: true,
        ...(this.direction === 'ttb' ? { 
          height: this.height,
          autoHeight: false 
        } : {}),
        arrows: this.showarrows,
        rewind: this.rewindDesktop,
        pagination: this.showdots,
        isNavigation: this.isNavigation,
        drag: !this.disableDrag,
        direction: this.direction,
        destroy: this.destroyOnDesktop,
        padding: { left: this.desktopPaddingLeft, right: this.desktopPaddingRight },
        omitEnd: this.omitEnd,
        perMove: this.perMove,
        breakpoints: {
          1149: {
            perPage: this.tabletPerPage,
            perMove: this.tabletpermove || 1,
            focus: 'center',
            padding: { left: this.tabletPaddingLeft, right: this.tabletPaddingRight },
            pagination: this.showdotsonmobile,
            ...(this.updateOnMove ? { updateOnMove: true } : {}), // <<< Only add if data-updateonmove="true"
            direction: this.tabletDirection,
            ...(this.tabletDirection !== 'ttb' ? { height: 'auto' } : { height: this.height })
          },
          768: {
            perPage: this.tabletPerPage,
            perMove: this.tabletpermove || 1,
            focus: 'center',
            padding: { left: this.tabletPaddingLeft, right: this.tabletPaddingRight },
            pagination: this.showdotsonmobile,
            ...(this.updateOnMove ? { updateOnMove: true } : {}), // <<< Only add if data-updateonmove="true"
            direction: this.tabletDirection,
            ...(this.tabletDirection !== 'ttb' ? { height: 'auto' } : { height: this.height })
          },
          490: {
            perPage: this.mobilePerPage,
            perMove: this.mobilepermove || 1,
            focus: 'center',
            arrows: this.showarrowsonmobile,
            pagination: this.showdotsonmobile,
            gap: this.gapMobile,
            destroy: this.destroyOnMobile,
            direction: this.mobileDirection,
            padding: { left: this.mobilePaddingLeft, right: this.mobilePaddingRight },
            ...(this.updateOnMove ? { updateOnMove: true } : {}), // <<< Only add if data-updateonmove="true"
            ...(this.mobileDirection !== 'ttb' ? { height: 'auto' } : { height: this.height })
          }
        },
      };

      if (typeof Splide === 'undefined') {
        console.error('Carousel: Splide library not loaded');
        return;
      }
      this.carousel = new Splide(this.carouselElement, config);
      
      if (
        !this.carouselElement.closest('.product') &&
          window.innerWidth > 749 &&
          !this.disableWheel
        ) {
          this.carouselElement.addEventListener('wheel', (event) => {
            if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
              event.preventDefault();
              if (!this.carousel.Components.Controller.isBusy()) {
                if (event.deltaX > 0) {
                  this.carousel.go('>');
                } else if (event.deltaX < 0) {
                  this.carousel.go('<');
                }
              }
            }
          });
      }

      if (this.sync) {
        setTimeout(() => {
          this.initCarouselSync()
        }, 100)
      } else {
        this.carousel.mount();

        if (this.refresh)
          this.carousel.refresh()
        
        setTimeout(() => {
          this.carouselElement.classList.add('is-initialized');
        }, 50);
      }
    }

    initCarouselSync() {
      this.syncElement = document.querySelector(this.sync);
      this.direction = this.syncElement.dataset['direction'] || 'ltr'
      
      this.carouselSync = new Splide(this.sync, {
        ...(this.updateOnMove ? { updateOnMove: true } : {}), // <<< Only add if data-updateonmove="true"
        perPage: this.syncElement.dataset['desktopperpage'] || 4,
        type: this.syncElement.dataset['type'] || 'loop',
        focus: this.syncElement.dataset['focus'] || 'center',
        isNavigation: this.syncElement.dataset['isnavigation'] === 'true' || false,
        pagination: false,
        gap: this.gap,
        snap: true,
        arrows: this.syncElement.dataset['showarrows'] === 'true' || false,
        drag: true,
        ...(this.direction === 'ttb' && {
          height: this.getPrimarySlideFirstImageHeight(),
          direction: 'ttb',
          autoHeight: true,
        }),
        breakpoints: {
          767: {
            height: 'auto',
            direction: this.mobileDirection,
            gap: this.gapMobile,
            arrows: this.showarrowsonmobile,
            ...(this.updateOnMove ? { updateOnMove: true } : {}) // <<< Only add if data-updateonmove="true"
          }
        },
      });
      
      this.carousel.sync(this.carouselSync);
      this.carousel.mount();
      this.carouselSync.mount();
      
      setTimeout(() => {
        this.carouselElement.classList.add('is-initialized');
      }, 50);
    }
    
    refreshSlider() {
      this.carousel.refresh();
      if (this.carouselSync) {
        this.carouselSync.refresh();
      }
    }

    getPrimarySlideFirstImageHeight() {
      const list = this.querySelector('.splide__list');
      if (!list) return 'auto';

      const image = list.querySelector('img');
      if (!image) return 'auto';

      const containerWidth = list.clientWidth;
      if (!containerWidth) return 'auto';

      const originalWidth = image.getAttribute('width');
      const originalHeight = image.getAttribute('height');

      if (!originalWidth || !originalHeight) return 'auto';

      return (containerWidth / originalWidth) * originalHeight;
    }
  }

  window.Carousel = Carousel;
  customElements.define('carousel-component', Carousel);
}
